// extracted by mini-css-extract-plugin
export var hidden = "_ss-0";